module.exports = __webpack_public_path__ + "static/img/img6.652e82c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/img6.jpg
// module id = 8e0H
// module chunks = 0